import React from 'react';
import styled from 'styled-components';

import CommentCard from './CommentCard';

const StyledCommentList = styled.div`
  margin-top: 24px;
`;

const CommentList = ({ comments }) => {
  if (!comments || !comments.length) {
    return null;
  }
  return (
    <StyledCommentList>
      {(comments || []).map(comment => (
        <CommentCard key={`comment-${comment.id}`} comment={comment} />
      ))}
    </StyledCommentList>
  );
};

export default CommentList;
